import React from 'react';
import { Button, Text, Flex, Link, Box } from 'rebass';
import { MAX_WIDTH } from '../common';

interface IProps {
  onStartOver: () => void;
}

export default function Credit({ onStartOver }: IProps) {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      px="20px"
      style={{
        width: '100%',
        height: '100vh',
        color: 'white',
        fontWeight: 'bold',
        maxWidth: MAX_WIDTH,
        margin: '40px auto',
      }}
    >
      <Text>축하합니다🎉🎉🎉 모든 문제를 맞혔습니다</Text>
      <Text fontSize="30px">💯</Text>
      <Box mt="20px" />
      <Text>
        Powered by{' '}
        <Link
          href="https://reactjs.org/"
          target="_blank"
          style={{ color: 'white' }}
        >
          react
        </Link>
        ,{' '}
        <Link
          href="https://github.com/mojs/mojs"
          target="_blank"
          style={{ color: 'white' }}
        >
          mojs
        </Link>
      </Text>
      <Button
        bg="black"
        mt="20px"
        onClick={onStartOver}
        style={{ cursor: 'pointer' }}
      >
        처음으로
      </Button>
    </Flex>
  );
}
